import React from 'react';
import { Accordion } from './ui/Accordion';
import { HelpCircle } from 'lucide-react';
import { Button } from './ui/Button';
const objections = [{
  title: '🤔 "No sé si esto es para mí, juego hace poco tiempo."',
  answer: 'El sistema está pensado para jugadoras de TODOS los niveles. Si recién empezás, te va a ahorrar años de prueba y error porque vas a aprender a leer el juego desde el día uno. Si ya jugás hace tiempo, te va a llevar al siguiente nivel competitivo sin tener que cambiar de club, entrenador ni rutina.'
}, {
  title: '⏰ "No tengo tiempo para leer 300+ páginas."',
  answer: 'No tenés que leer todo de una. Cada capítulo es independiente y está dividido en secciones cortas que podés aplicar al día siguiente en el entrenamiento. Con leer 15 minutos antes de ir a entrenar ya vas a notar la diferencia en cómo te movés y decidís en cancha.'
}, {
  title: '💸 "¿Es seguro pagar? ¿Y si no me sirve?"',
  answer: 'El pago se procesa con encriptación de nivel bancario y aceptamos todos los medios de pago de Argentina (Mercado Pago, tarjeta de crédito, débito y más). Comprás con total tranquilidad y recibís tu material al instante.'
}, {
  title: '📱 "¿Cómo lo recibo después de pagar?"',
  answer: 'Apenas confirmás tu compra, recibís un email con el acceso a los PDFs. Los podés descargar al celular, tablet o computadora y consultarlos cuando quieras, sin conexión a internet. El acceso es de por vida — no tiene vencimiento.'
}, {
  title: '🏃‍♀️ "Ya entreno mucho, ¿realmente voy a notar la diferencia?"',
  answer: 'Justamente porque ya entrenás mucho es que vas a notar el cambio rápido. El problema de la mayoría no es falta de esfuerzo, es falta de criterio táctico y mental. Cuando empezás a entrenar con un sistema y un plan, el mismo esfuerzo te rinde el doble.'
}, {
  title: '🎯 "¿Sirve para mi posición específica?"',
  answer: 'Sí. El Capítulo 6 está dedicado a roles y posiciones: volante central, extremos modernos, defensoras centrales, delanteras, laterales ofensivas. Cada posición tiene sus claves tácticas y técnicas específicas explicadas en detalle.'
}, {
  title: '😟 "Me da miedo competir, ¿esto me va a ayudar?"',
  answer: 'El Capítulo 4 y el Bono 5 están enfocados 100% en mentalidad competitiva: cómo dejar de jugar con miedo, controlar los nervios pre partido, recuperar la confianza después de fallar y competir con personalidad. Es uno de los módulos que más impacto genera.'
}];
export function Objections() {
  return <section className="py-20 bg-brand-dark text-white px-4" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-pink/15 text-brand-pink mb-5" data-id="element-76">
            <HelpCircle className="w-7 h-7" data-id="element-77" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-3" data-id="element-78">
            Preguntas <span className="text-brand-pink" data-id="element-79">frecuentes</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-400 font-medium" data-id="element-80">
            Sacate todas las dudas antes de decidirte.
          </p>
        </div>

        <div className="space-y-4" data-id="element-81">
          {objections.map((obj, i) => <Accordion key={i} title={obj.title} data-id="element-82">
              <p className="text-zinc-300 leading-relaxed" data-id="element-83">{obj.answer}</p>
            </Accordion>)}
        </div>

        <div className="text-center mt-12" data-id="element-84">
          <p className="text-zinc-400 mb-5 font-medium" data-id="element-85">
            ¿Sigue alguna duda? Confiá en tu instinto — el sistema fue diseñado
            para vos.
          </p>
          <Button className="text-lg py-5 px-10" data-id="element-86">DOMINÁ TUS PARTIDOS</Button>
        </div>
      </div>
    </section>;
}